module.exports = __webpack_public_path__ + "img/cg_big_tree.975d2902.jpg";